import _ from 'lodash';
import moment from 'moment-timezone';
import 'moment-precise-range-plugin';

    function byteToHex(byte) {
        return _.padStart(byte.toString(16), 2, '0');
    }

    function convertMomentToUtc(datetimeMoment) {
        moment.tz.setDefault(moment.tz.guess());
        return (_.cloneDeep(datetimeMoment)).utc();
    }

    function formatDatetime(datetimeMoment) {
        return datetimeMoment.format('YYYY-MM-DDTHH:mm:ss') + 'Z';
    }

    function getDurationDisplayText(preciseDiff) {
        var display = '';
        if (preciseDiff.years > 0) {
            display += preciseDiff.years + 'y ' + preciseDiff.months + 'm ' + preciseDiff.days + 'd ' + preciseDiff.hours + 'h ' + preciseDiff.minutes + 'm ' + preciseDiff.seconds + 's';
        }
        else if (preciseDiff.months > 0) {
            display += preciseDiff.months + 'm ' + preciseDiff.days + 'd ' + preciseDiff.hours + 'h ' + preciseDiff.minutes + 'm ' + preciseDiff.seconds + 's';
        }
        else if (preciseDiff.days > 0) {
            display += preciseDiff.days + 'd ' + preciseDiff.hours + 'h ' + preciseDiff.minutes + 'm ' + preciseDiff.seconds + 's';
        }
        else if (preciseDiff.hours > 0) {
            display += preciseDiff.hours + 'h ' + preciseDiff.minutes + 'm ' + preciseDiff.seconds + 's';
        }
        else if (preciseDiff.minutes > 0) {
            display += preciseDiff.minutes + 'm ' + preciseDiff.seconds + 's';
        }
        else if (preciseDiff.seconds >= 0) {
            display += preciseDiff.seconds + 's';
        }
        return display;
    }

    const thresholdMap = {
        jitter: {
            audio: [100, 200],
            video: [150, 300],
            presentation: [500, 750],
        },
        packetLoss: {
            audio: [1.0, 2.0],
            video: [1.5, 3.0],
            presentation: [3.0, 6.0],
        },
        latency: {
            audio: [250, 300],
            video: [300, 400],
            presentation: [750, 1000],
        },
    };

    const other = {
        jitter: [20, 60],
        latency: [250, 300]
    };

    function isFloat(n) {
        return n === +n && n !== (n | 0);
    }

    function isInteger(n) {
        return n === +n && n === (n | 0);
    }

    export default {
        convertMomentToUtcAndFormatServerReady: _.flowRight([formatDatetime, convertMomentToUtc]),

        //  adapted from "How to generate random hash to use as ID?" - https://stackoverflow.com/a/14869745
        generateID: function (crypto) {
            var id;

            // try to get really random hash via 'crypto.getRandomValues' (using typed arrays):
            try {
                var arr = new Uint8Array(10);
                var crypto = crypto || window.crypto || window.msCrypto;
                crypto.getRandomValues(arr);
                id = [].map.call(arr, byteToHex).join("");

            // if 'Uint8Array' is not supported by the browser, create a pseudo-random hash instead:
            } catch (e) {
                id = ((new Date().valueOf()).toString(36) + Math.random().toString(36)).replace('.', '');
            }

            return id.slice(0, 10);
        },

        createUUID: function (crypto) {
            var crypto = crypto || window.crypto || window.msCrypto;
            return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
                (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
        },
        generateUID: function (crypto) {
            return this.generateID(crypto);
            // return (new Date().valueOf()).toString(36); // returns unique hashes e.g. "j2w4tt8e"
        },

getDurationDisplayTextFromDiff: function (starttime, endtime) {
            return getDurationDisplayText(endtime.preciseDiff(starttime, true));
            },
        
        getDurationDisplayTextFromSeconds: function (value) {
            return getDurationDisplayText(moment.unix(value).preciseDiff(moment.unix(0), true));
        },

        convertToSeconds: function (value) {
            if (!isNaN(value)) {
                return +value;
            } 
            value = value.replace(/,/g, "");
            if (!isNaN(value)) {
                return +value;
            }

            if (value && value.toLocaleLowerCase() === 'invalid') { // MOS
            return -2;
            }
            let result = 0;

            let regExpBytes = /^(\d+)\s([KMGTPEZY]B|bytes)$/ig;
            let foundBytes = regExpBytes.exec(value);
            if (foundBytes && foundBytes.length > 2) {
                switch (foundBytes[2]) {
                    case 'YB': result += 1000*1000*1000*1000*1000*1000*1000*1000*foundBytes[1]; break;
                    case 'ZB': result += 1000*1000*1000*1000*1000*1000*1000*foundBytes[1]; break;
                    case 'EB': result += 1000*1000*1000*1000*1000*1000*foundBytes[1]; break;
                    case 'PB': result += 1000*1000*1000*1000*1000*foundBytes[1]; break;
                    case 'TB': result += 1000*1000*1000*1000*foundBytes[1]; break;
                    case 'GB': result += 1000*1000*1000*foundBytes[1]; break;
                    case 'MB': result += 1000*1000*foundBytes[1]; break;
                    case 'KB': result += 1000*foundBytes[1]; break;
                    case 'bytes': result += 1*foundBytes[1]; break;
                    default: break;
                }
            }


            let parts = value.split(/\s+/);
            parts.forEach(function (token) {
                if (token) {
                    let regExp = /(\d+)([dhms])/gi;
                    let found = regExp.exec(token);
                    if (found && found.length > 2) {
                        switch (found[2]) {
                            case 'd':
                            case 'D': result += 60*60*24*found[1]; break;
                            case 'h':
                            case 'H': result += 60*60*found[1]; break;
                            case 'm':
                            case 'M': result += 60*found[1]; break;
                            case 's':
                            case 'S': result += 1*found[1]; break;
                            default: break;
                        }
                    }
                }
            });
            return result;
        },

        formatThreshold: function(metric, channel, levels, def, val) {
            var valAsNumber = Number(val);
            var className = def;

            if (isFloat(valAsNumber) || isInteger(valAsNumber)) {
                // channel must be one of these three options: 'audio' 'video' 'presentation'
                // This value comes from the xmldetails-formatter-helper.js GetFormattedValue function

                let thresholds = _.get(thresholdMap, [metric, channel], _.get(other, metric));
                if (thresholds) {
                    if (valAsNumber < thresholds[0]) {
                        className = levels[0];
                    } else if (valAsNumber > thresholds[1]) {
                        className = levels[2];
                    } else {
                        className = levels[1];
                    }
                }
            }
            return className;
        },

        dispatchSignal: function (signal, value) {
            if (signal && _.isFunction(_.get(signal, 'dispatch'))) {
                if (signal._bindings) {
                    if (_.isArray(value)) {
                      signal.dispatch(...value);
                    } else {
                      signal.dispatch(value);
                    }
                }
            }
        }

};
